import { render, staticRenderFns } from "./courtship.vue?vue&type=template&id=3dcfa104&scoped=true&"
import script from "./courtship.vue?vue&type=script&lang=js&"
export * from "./courtship.vue?vue&type=script&lang=js&"
import style0 from "./courtship.vue?vue&type=style&index=0&id=3dcfa104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcfa104",
  null
  
)

export default component.exports